import { render, staticRenderFns } from "./SustainabilityAtRegatta.vue?vue&type=template&id=971e4974&scoped=true&"
import script from "./SustainabilityAtRegatta.vue?vue&type=script&lang=js&"
export * from "./SustainabilityAtRegatta.vue?vue&type=script&lang=js&"
import style0 from "./SustainabilityAtRegatta.vue?vue&type=style&index=0&id=971e4974&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "971e4974",
  null
  
)

export default component.exports